import { request } from './request'

export const getListEmail = data => {
  const url = '/ocean/api/v1/cs/inbox/list'
  return request({
    method: 'post',
    url: url,
    data
  })
}

export const getLogList = (userId, params) =>
  request({
    method: 'get',
    url: `/ocean/api/v1/admin/bm/user/${userId}/log`,
    params
  })
export const getEmailInfoList = params =>
  request({
    method: 'get',
    url: '/ocean/api/v1/cs/account/list',
    params
  })

export const updateEmailInfoList = data =>
  request({
    method: 'put',
    url: '/ocean/api/v1/cs/account/enableOrDisable',
    data
  })
export const updateServiceEmail = data => {
  const url = '/ocean/api/v1/cs/account/saveOrUpdate'
  return request({
    method: 'post',
    url: url,
    data
  })
}
//收件箱-获取预警时间
export const getEmailOverTime = params => {
  const url = '/ocean/api/v1/merchant/getSetting'
  return request({
    method: 'get',
    url: url,
    params
  })
}
//收件箱-获取预警时间
export const setEmailOverTime = data => {
  const url = `/ocean/api/v1/merchant/editSetting`
  return request({
    method: 'post',
    url: url,
    data
  })
}
// 获取邮箱列表
export const getEmailList = params => {
  const url = '/ocean/api/v1/cs/account/list/email'
  return request({
    method: 'get',
    url: url,
    params
  })
}
// 获取邮箱默认设置
export const getEmailsetting = params => {
  const url = '/ocean/api/v1/cs/account/get/default/information'
  return request({
    method: 'get',
    url: url,
    params
  })
}
// 设置邮箱排序
export const setEmailSequence = data => {
  const url = '/ocean/api/v1/cs/account/set/sequence'
  return request({
    method: 'put',
    url: url,
    data
  })
}

// 邮件签名
export const editSignature = data =>
  request({
    method: 'put',
    url: '/ocean/api/v1/cs/account/editSignature',
    data
  })

export const updateInfo = (userId, data) =>
  request({
    method: 'put',
    url: `/api/v1/admin/bm/user/${userId}`,
    data
  })

export const getDetail = userId =>
  request({
    method: 'get',
    url: `/api/v1/admin/bm/user/${userId}`
  })
export const updateEmailListItemTag = data =>
  request({
    method: 'put',
    url: '/ocean/api/v1/cs/inbox/settags',
    data
  })
export const updateEmailListItemType = data =>
  request({
    method: 'put',
    url: '/ocean/api/v1/cs/inbox/setCategory',
    data
  })
export const updateEmailListItemStaff = data =>
  request({
    method: 'put',
    url: '/ocean/api/v1/cs/inbox/setstaff',
    data
  })
export const updateEmailSend = data =>
  request({
    method: 'post',
    url: '/ocean/api/v1/cs/outbox/sendMail',
    data
  })
// 历史订单-获取客户关联邮箱
export const getEmailFromOrder = params =>
  request({
    method: 'get',
    url: '/ocean/api/v1/cs/customerEmail/getUserBinding',
    params
  })
// 收件箱-邮件详情
export const getEmailDetail = params =>
  request({
    method: 'get',
    url: '/ocean/api/v1/cs/inbox/detail',
    params
  })
// 收件箱-邮件详情 -备注
export const putEmailRemark = data =>
  request({
    method: 'put',
    url: '/ocean/api/v1/cs/inbox/remark',
    data
  })
// 客服邮箱-获取店铺列表
export const getEmailShopList = params =>
  request({
    method: 'get',
    url: '/ocean/api/v1/cs/account/getShopList',
    params
  })
// 收件箱-邮件绑定店铺
export const putSetShopId = data =>
  request({
    method: 'put',
    url: '/ocean/api/v1/cs/inbox/setShopId',
    data
  })

// 历史订单-绑定用户邮箱
export const postUserBindingEmail = data =>
  request({
    method: 'post',
    url: '/ocean/api/v1/cs/customerEmail/userBinding',
    data
  })
// 售后订单-获取售后单详情
export const getAfterOrderDetail = params =>
  request({
    method: 'get',
    url: '/ocean/api/v1/order/refund/detail',
    params
  })
// 售后订单-新增售后单
export const addRefundOrder = data =>
  request({
    method: 'post',
    url: '/ocean/api/v1/order/refund/create',
    data
  })
// 售后订单-编辑售后单
export const updateRefundOrder = data =>
  request({
    method: 'post',
    url: '/ocean/api/v1/order/refund/update',
    data
  })
// 往来邮件-查询列表
export const getEmailContact = params =>
  request({
    method: 'get',
    url: '/ocean/api/v1/cs/customerEmail/contacts',
    params
  })

// 邮件配置-获取邮件签名
export const getEmailSign = params =>
  request({
    method: 'get',
    url: '/ocean/api/v1/cs/account/signature/get',
    params
  })

// 邮件配置-手动设置邮件状态
export const setEmailStatus = data =>
  request({
    method: 'PUT',
    url: '/ocean/api/v1/cs/inbox/setReplayStatus',
    data
  })

// 售后订单-订单列表
export const postOrderList = data =>
  request({
    method: 'post',
    url: '/ocean/api/v1/order/refund/list',
    data
  })

// 售后订单-取消订单
export const getCloseOrder = data =>
  request({
    method: 'post',
    url: '/ocean/api/v1/order/cancel',
    data
  })

// 售后订单-申请退款
export const getRefundOrder = data =>
  request({
    method: 'post',
    url: '/ocean/api/v1/order/update/refund/status',
    data
  })

// 售后订单-修改状态
export const changeRefundOrderStatus = data =>
  request({
    method: 'post',
    url: '/ocean/api/v1/order/update/refund/status',
    data
  })

// 售后订单-导出
export const exportExcel = data =>
  request({
    method: 'post',
    url: '/ocean/api/v1/order/refund/export',
    responseType: 'blob',
    data
  })

// 售后订单-售后单可退金额
export const getCreateDetail = params =>
  request({
    method: 'get',
    url: '/ocean/api/v1/order/refund/refund-view',
    params
  })

// 售后订单-查询可退款订单
export const getOrderList = data =>
  request({
    method: 'post',
    url: '/ocean/api/v1/order/orderRefundPage',
    data
  })

// 获取商品列表
export const getPopoverList = refundId =>
  request({
    method: 'get',
    url: `/ocean/api/v1/order/refund/${refundId}/sub-orders`
  })
